const headRowsTableActions = {
  id: 'ID',
  sponsor: 'Accountables',
  createdAt: 'Created at',
  deadline: 'Deadline',
  equipment: 'Equipment',
  itemVerification: 'Verification',
  place: 'Local',
  status: 'Status',
  action: 'Action',
};

export default headRowsTableActions;
